import { render, staticRenderFns } from "./AmountShop.vue?vue&type=template&id=431cf32d&scoped=true&"
import script from "./AmountShop.vue?vue&type=script&lang=js&"
export * from "./AmountShop.vue?vue&type=script&lang=js&"
import style0 from "./AmountShop.vue?vue&type=style&index=0&id=431cf32d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cf32d",
  null
  
)

export default component.exports